import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCameraSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M15.2695 3.35254L13 4.22656V7.77344L16.0518 8.94727L17.2266 12H20.7734L21.9473 8.94727L22 8.92676V21H2V6H6.96484L8.96484 3H15.0352L15.2695 3.35254ZM12 10C10.067 10 8.5 11.567 8.5 13.5C8.5 15.433 10.067 17 12 17C13.933 17 15.5 15.433 15.5 13.5C15.5 11.567 13.933 10 12 10Z" fill="currentColor"/><Path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraSparkle;
